import { ListValidator } from '../list/list.validator'
import { AssetIdValidator } from './asset-id.validator'

export const AssetIdListValidator = ListValidator(AssetIdValidator)
